export { default } from './Quiz'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Quiz/index.js